import { BaseModel } from 'app/core/_base/crud';
    export class KhieuNaiKhachHangModel extends BaseModel {
            Id : number
            SoPhieu : string
            NgayTao : string
            NguoiTao : string
            TinhTrang : string
            KhachHangId : string
            NguoiTiepNhan : string
            NgayTiepNhan : string
            TenKH:string
            TenNguoiTao:string
            NgayQAPhanHoi:string
            listKNDetail:KhieuNaiKhachHangCTModel[]
        clear() {
                this.Id = 0;
                this.SoPhieu = '';
                this.NgayTao = '';
                this.NguoiTao = '';
                this.TinhTrang = '';
                this.KhachHangId = '';
                this.NguoiTiepNhan = '';
                this.NgayTiepNhan = '';
                this.TenKH='';
                this.TenNguoiTao='';
                this.NgayQAPhanHoi='';
                this.listKNDetail=[];
        }
        copy(item:KhieuNaiKhachHangModel){
                this.Id = item.Id;
                this.SoPhieu = item.SoPhieu;
                this.NgayTao = item.NgayTao;
                this.NguoiTao = item.NguoiTao;
                this.TinhTrang = item.TinhTrang;
                this.KhachHangId = item.KhachHangId;
                this.NguoiTiepNhan = item.NguoiTiepNhan;
                this.NgayTiepNhan = item.NgayTiepNhan;
                this.TenKH=item.TenKH;
                this.listKNDetail=item.listKNDetail;
                this.TenNguoiTao=item.TenNguoiTao;
                this.NgayQAPhanHoi=item.NgayQAPhanHoi;
        }
    }



    export class KhieuNaiKhachHangCTModel extends BaseModel {
        Id :number
         KhieuNaiKhachHangId:number 
         HangHoaId :string
         SoLuong :string
         SoPhieuGiaoHang:string 
         SoLotSanPham :string
         NgaySanXuat :string
         MoTaVanDe :string
         KiemTraHienTruong :boolean
         KyHanKiemTraHienTruong :string
         BaoCaoKhacPhuc :boolean
         KyHanBaoCaoKhacPhuc :string
         YeuCauKhac :string
         TinhTrang :string
         XacNhanTinhTrang :string
         ThongTinBoSung :string
         BuHang :boolean
         NgayBuHang :string
         CanTruCongNo :boolean
         SoHoaDon :string
         PhuongAnKhac :boolean
         DienGiai :string
         GhiChuCuaQc :string
         DenBuThietHai:boolean
         GiaTriDenBu:string
         KienNghiHangHoa:string
         NoiDungYKienKhac:string
         NgayYeuCauPhanHoi:string
         DinhKemFileKhachHang_Id:string
         DinhKemFileKiemTra_Id:string
         DinhKemFileXuLy_Id:string
         XuLyKhongPhuHop:boolean
         YKienKhachHang:string
         listLoaiLoiKN:string[]
         listAttachMent:FileAttachmentModel[]
         listAttachMent_KiemTra:FileAttachmentModel[]
         listAttachMent_XuLy:FileAttachmentModel[]
        //expand
         SoPhieu :string
         MaHH :string
         TenHH :string
         TenKH :string;
         NgayTiepNhan :string
       //
    clear() {
        this.Id =0;
        this.KhieuNaiKhachHangId= 0;
        this.HangHoaId ='';
        this.SoLuong ='';
        this.SoPhieuGiaoHang='' ;
        this.SoLotSanPham ='' ;
        this.NgaySanXuat ='' ;
        this.MoTaVanDe ='' ;
        this.KiemTraHienTruong =false;
        this.KyHanKiemTraHienTruong ='' ;
        this.BaoCaoKhacPhuc =false;
        this.KyHanBaoCaoKhacPhuc='' ;
        this.YeuCauKhac ='' ;
        this.TinhTrang ='' ;
        this.XacNhanTinhTrang ='' ;
        this.ThongTinBoSung ='' ;
        this.BuHang  =false;
        this.NgayBuHang ='' ;
        this.CanTruCongNo  =false;
        this.SoHoaDon ='' ;
        this.PhuongAnKhac  =false;
        this.DienGiai ='' ;
        this.GhiChuCuaQc ='' ;
        this.DenBuThietHai=false;
        this.GiaTriDenBu='0,00';
        this.KienNghiHangHoa='';
        this.NoiDungYKienKhac='';
        this.NgayYeuCauPhanHoi='';
        this.DinhKemFileKhachHang_Id='0';
        this.DinhKemFileKiemTra_Id='0';
        this.DinhKemFileXuLy_Id='0';
        this.XuLyKhongPhuHop=false;
        this.YKienKhachHang='';
        this.listLoaiLoiKN=[];
        this.listAttachMent=[],
        this.listAttachMent_KiemTra=[],
        this.listAttachMent_XuLy=[],
       //expand
       this.SoPhieu ='' ;
       this.MaHH ='' ;
       this.TenHH ='' ;
       this.TenKH ='' ;
       this.NgayTiepNhan ='' ;
      //
    }
    copy(item:KhieuNaiKhachHangCTModel){
        this.Id =item.Id;
        this.KhieuNaiKhachHangId= item.KhieuNaiKhachHangId;
        this.HangHoaId =item.HangHoaId;
        this.SoLuong =item.SoLuong;
        this.SoPhieuGiaoHang=item.SoPhieuGiaoHang ;
        this.SoLotSanPham =item.SoLotSanPham ;
        this.NgaySanXuat =item.NgaySanXuat ;
        this.MoTaVanDe =item.MoTaVanDe ;
        this.KiemTraHienTruong =item.KiemTraHienTruong;
        this.KyHanKiemTraHienTruong =item.KyHanKiemTraHienTruong ;
        this.BaoCaoKhacPhuc =item.BaoCaoKhacPhuc;
        this.KyHanBaoCaoKhacPhuc=item.KyHanBaoCaoKhacPhuc ;
        this.YeuCauKhac =item.YeuCauKhac ;
        this.TinhTrang =item.TinhTrang ;
        this.XacNhanTinhTrang =item.XacNhanTinhTrang ;
        this.ThongTinBoSung =item.ThongTinBoSung ;
        this.BuHang  =item.BuHang;
        this.NgayBuHang =item.NgayBuHang ;
        this.CanTruCongNo  =item.CanTruCongNo;
        this.SoHoaDon =item.SoHoaDon ;
        this.PhuongAnKhac  =item.PhuongAnKhac;
        this.DienGiai =item.DienGiai ;
        this.GhiChuCuaQc =item.GhiChuCuaQc ;
        this.DenBuThietHai=item.DenBuThietHai;
        this.GiaTriDenBu=item.GiaTriDenBu;
        this.KienNghiHangHoa=item.KienNghiHangHoa;
        this.NoiDungYKienKhac=item.NoiDungYKienKhac;
        this.NgayYeuCauPhanHoi=item.NgayYeuCauPhanHoi;
        this.DinhKemFileKhachHang_Id=item.DinhKemFileKhachHang_Id;
        this.DinhKemFileKiemTra_Id=item.DinhKemFileKiemTra_Id;
        this.DinhKemFileXuLy_Id==item.DinhKemFileXuLy_Id;
        this.XuLyKhongPhuHop=item.XuLyKhongPhuHop;
        this.YKienKhachHang=item.YKienKhachHang;
        this.listLoaiLoiKN=item.listLoaiLoiKN;
        this.listAttachMent=item.listAttachMent;
        this.listAttachMent_KiemTra=item.listAttachMent_KiemTra,
        this.listAttachMent_XuLy=item.listAttachMent_XuLy,
       //expand
       this.SoPhieu =item.SoPhieu ;
       this.MaHH =item.MaHH ;
       this.TenHH =item.TenHH ;
       this.TenKH =item.TenKH ;
       this.NgayTiepNhan =item.NgayTiepNhan ;
      //
    }
}


export class FileAttachmentModel extends BaseModel {
    Id : number
    base64 : string
    fileByte : string
    filename : string
    extension : string
    urlfile : string
    sttct : string
clear() {
        this.Id = 0;
        this.base64 = '';
        this.fileByte = '';
        this.filename = '';
        this.extension = '';
        this.urlfile = '';
        this.sttct = '';
}
copy(item:FileAttachmentModel){
        this.Id = item.Id;
        this.base64 = item.base64;
        this.fileByte = item.fileByte;
        this.filename = item.filename;
        this.extension = item.extension;
        this.urlfile = item.urlfile;
        this.sttct = item.sttct;
}
}